import classNames from "classnames";

export default function Checkbox(props: {
  size?: string; // small, medium, normal
  disabled?: boolean;
  className?: string;

  checked?: boolean;
  value?: number;
  onClick?: () => void;
  onChange?: (value: any) => void;
}) {
  let { size = "", disabled = false, className = "", ...properties } = props;

  const classes = classNames("checkbox", {
    [`is-${size}`]: size.length,
    [className]: className.length,
  });

  return (
    <input
      className={classes}
      type="checkbox"
      checked={props.checked}
      disabled={disabled}
      {...properties}
    />
  );
}
